
export default function DivBonus1 (){
    return  <div className="DIV_LÓT    w-full h-0 7:h-c16 bg-black "></div>
}